import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { EventStateActions } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/EventActionsState/EventActionsState';
import { action, computed, observable, makeAutoObservable } from 'mobx';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

export class AvailableOnState {
    @observable isLoadingEventUpdate: boolean = false;

    public constructor(
        private readonly eventIdInner: () => EventId,
        private readonly sdkStaff: SdkStaff,
        private readonly eventStateActions: EventStateActions
    ) {
        makeAutoObservable(this);
    }

    @computed get eventId(): EventId {
        return this.eventIdInner();
    }

    @computed get eventModel(): EventModel | null {
        return this.eventId.getEventModel();
    }

    @computed get antePost(): boolean | undefined {
        return this.eventModel?.antePost;
    }

    @action onChangeAntePost = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const antePost = e.currentTarget.checked;

        await this.performUpdate({
            antePost,
        });
    };

    @action performUpdate = async (body: { antePost: boolean }): Promise<void> => {
        this.isLoadingEventUpdate = true;
        await this.sdkStaff.updateEvent({ event_id: this.eventId.toOldId(), requestBody: body });
        await this.eventStateActions.triggerUpdateEvent(this.eventId);
        this.isLoadingEventUpdate = false;
    };
}
